import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/benning/Desktop/unchai-restaurant/src/components/MenuPageClient.tsx");
